import { generateRequest } from '.';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Brands: {
    BrandsPending: 'Brands_PENDING',
    BrandsCompleted: 'Brands_FULFILLED',
    BrandsFailed: 'Brands_FAILED',
  },
};

export const fetchBrands = (brandIds = []) => generateRequest({
  endpoint: `/assets-v2/api/brands${brandIds.length ? `?${toQueryString({ brandIds })}` : ''}`,
  types: [
    Action.Brands.BrandsPending,
    Action.Brands.BrandsCompleted,
    Action.Brands.BrandsFailed,
  ],
});
